import { createContext } from 'react';
import type { Context } from './MyWidgetsProvider.types';

export const MyWidgetsContext = createContext<Context>({ myWidgets: undefined });
